import React from "react";
import {
   BrowserRouter as Router,
   Switch,
   Route,
   Link
} from "react-router-dom";
import PageContact from "./page_contact";
import PageDrumTrainer from "./page_drum_trainer";
import PageFeedMeWeather from "./page_feed_me_weather";
import styles from "./styles.module.css";

export default PageStart

function PageStart() {
   return (
      <Router>
         <div className={styles.body}>
            <Link to="/drum_trainer">Drum Trainer</Link>
            .  .
            <Link to="/feedMeWeather">FeedMeWeather</Link>
            .  .
            <Link to="/contact">Contact</Link>
         </div>
         <Switch>
            <Route path="/drum_trainer">
               <PageDrumTrainer />
            </Route>
            <Route path="/feedMeWeather">
               <PageFeedMeWeather />
            </Route>
            <Route path="/contact">
               <PageContact />
            </Route>
         </Switch>
      </Router>

   );
}